import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { actions, selectors } from 'shared/store'
import { LoadingStatus, UserActions, UserRole } from 'shared/types'
import { useUserRole } from 'shared/hooks'
import { paths } from 'modules/Config/strings'
import { paths as homePaths } from 'modules/Home/strings'

const getNextAction = (currentActions: UserActions) => {
  if (currentActions.isCompanyDataIncomplete) return paths.company
  if (!currentActions.isRegistrationComplete) return paths.accountant
  return homePaths.home
}

export const useUserActions = (): {
  actions: UserActions | null
  nextActionPath: string | null
  isLoadingFinished: boolean
} => {
  const dispatch = useDispatch()
  const { data, loading } = useSelector(selectors.users.getUserActions)
  const { isAllowed, loading: roleLoading } = useUserRole()

  const isLoadingFinished = loading === LoadingStatus.Succeeded
  const isUser = isAllowed(UserRole.User)

  useEffect(() => {
    if (isUser && roleLoading === LoadingStatus.Succeeded) {
      dispatch(actions.users.getUserActions({ disableRefetch: true }))
    }
  }, [dispatch, isUser, roleLoading])

  return {
    isLoadingFinished,
    actions: data,
    nextActionPath: isLoadingFinished ? getNextAction(data) : null,
  }
}
